import React, { useMemo } from 'react';
import { CustomEditor } from 'components/shared/CustomEditor';
import { resolveLanguageDisplayLabel } from 'utils/smartContent/translationLanguageUtils';
import './SmartContentPopintrad.css';

const SmartTextTranslationView = ({
  t,
  sourceContent,
  translatedContent,
  onTranslatedContentChange,
  sourceLanguageLabel,
  targetLanguageLabel,
  isTranslating,
  isSavingTranslation,
  onSaveTranslation,
  sourceTextId,
  renderSourceActions,
  getTextFromHtml,
  readOnly = false,
}) => {
  const sourceWordCount = useMemo(
    () => getTextFromHtml(sourceContent).split(/\s+/).filter((word) => word.length > 0).length,
    [sourceContent, getTextFromHtml]
  );

  const translatedWordCount = useMemo(() => {
    if (!translatedContent || isTranslating) return 0;
    return getTextFromHtml(translatedContent).split(/\s+/).filter((word) => word.length > 0).length;
  }, [translatedContent, isTranslating, getTextFromHtml]);

  const formatLanguageLabel = (label) =>
    resolveLanguageDisplayLabel(label).toUpperCase();

  return (
    <div className="smart-text-translation-view">
      <div className="smart-text-translation-grid">
        <div className="smart-text-translation-panel">
          <div className="smart-text-translation-panel-header">
            <span
              className="smart-text-translation-panel-dot"
              aria-hidden="true"
            />
            <span className="smart-text-translation-panel-label">
              {t('ORIGINAL')}
              {' — '}
              {formatLanguageLabel(sourceLanguageLabel)}
            </span>
          </div>
          <div className="box-wrapper-editor smart-text-translation-editor">
            <CustomEditor
              t={t}
              textId={sourceTextId}
              content={sourceContent}
              isReadOnly
              disabled={false}
              onInit={() => { }}
              onChange={() => { }}
              height="60vh"
            />
          </div>
        </div>

        <div className="smart-text-translation-panel">
          <div className="smart-text-translation-panel-header">
            <img
              src="/Images/Typix_Traduction-selection.png"
              alt=""
              className="smart-text-translation-panel-translate-icon"
              aria-hidden="true"
            />
            <span className="smart-text-translation-panel-label">
              {t('TRADUCTION')}
              {' — '}
              {formatLanguageLabel(targetLanguageLabel)}
            </span>
          </div>
          <div className="box-wrapper-editor smart-text-translation-editor">
            <CustomEditor
              t={t}
              content={translatedContent}
              isReadOnly={readOnly || isTranslating}
              disabled={isTranslating}
              allowConsultantEdit={false}
              onInit={() => { }}
              onChange={(value) => {
                if (readOnly) return;
                onTranslatedContentChange(value);
              }}
              height="60vh"
            />
          </div>
        </div>

        <div className="smart-text-translation-toolbar smart-text-translation-toolbar--left">
          <div className="smart-text-translation-toolbar-actions">
            {!readOnly && renderSourceActions?.()}
          </div>
          {sourceWordCount > 0 && (
            <div className="smart-text-translation-word-count">
              {sourceWordCount}
              {' '}
              {t('mots')}
            </div>
          )}
        </div>

        <div className="smart-text-translation-toolbar smart-text-translation-toolbar--right">
          {!readOnly && (
          <button
            type="button"
            className="smart-text-translation-save-btn"
            onClick={onSaveTranslation}
            disabled={isTranslating || isSavingTranslation || !translatedContent}
          >
            {isSavingTranslation ? t('Enregistrement...') : t('Enregistrer')}
          </button>
          )}
          {translatedWordCount > 0 && (
            <div className="smart-text-translation-word-count">
              {translatedWordCount}
              {' '}
              {t('mots')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SmartTextTranslationView;
